import { render, staticRenderFns } from "./bar-rank.vue?vue&type=template&id=2117521d&scoped=true&"
import script from "./bar-rank.vue?vue&type=script&lang=js&"
export * from "./bar-rank.vue?vue&type=script&lang=js&"
import style0 from "./bar-rank.vue?vue&type=style&index=0&id=2117521d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2117521d",
  null
  
)

export default component.exports